<template>
  <div class="hotspot">
    <el-form label-position="top" :rules="rules" ref="ruleForm" label-width="80px" :model="rulesForm">
      <vue-dividing-line title="基本設定"></vue-dividing-line>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="題目編號" prop="question_no">
            <el-input v-model="rulesForm.question_no" placeholder="請輸入題目編號"></el-input> </el-form-item
        ></el-col>
        <el-col :span="12">
          <el-form-item label="語言" prop="lang">
            <el-select v-model="rulesForm.lang" placeholder="請選擇語言">
              <el-option v-for="(item, index) in lang" :key="index"
                :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="分數" prop="score"> 
            <el-input-number v-model="rulesForm.score" controls-position="right" :min="1" placeholder="請輸入分數"></el-input-number>
          </el-form-item
        ></el-col>
        <!-- <el-col :span="12">
          <el-form-item label="難易程度" prop="level">
            <el-select v-model="rulesForm.level" placeholder="請選擇難度">
              <el-option v-for="(item, idx) in level" :key="idx"
                :label="item.label" :value="item.value">
              </el-option>
            </el-select> 
          </el-form-item
        ></el-col> -->
      </el-row>
      <vue-dividing-line title="問題"></vue-dividing-line>
      <el-form-item label="問題" prop="title">
        <Tinymce v-model="rulesForm.title" ref="Tinymce"></Tinymce>
      </el-form-item>
      <vue-dividing-line title="背景圖片、熱點及答案"></vue-dividing-line>
      <el-form-item label="背景圖片" prop="img_url">
        <upload :placeholder="rulesForm.img_url || '請選擇問題圖片'" @childByValue="onUploadSuccess"></upload>
        <div class="img-box" v-if="rulesForm.img_url">
          <div class="close" @click="rulesForm.img_url = ''"></div>
          <img :src="rulesForm.img_url" />
        </div>
      </el-form-item>
      <div><i class="el-icon-warning-outline"></i> 點擊長方形或者圓形按鈕以在圖片上設定熱點。</div>
      <div><i class="el-icon-warning-outline"></i> 在圖片中指定圖形上點擊右鍵以設定其為正確答案。該圖形顏色會轉為綠色。</div>

      <el-form-item label="" class="required" prop="choice_option">
        <div class="design">
          <div class="hotspot-canvas" :style="{backgroundImage: `url(${rulesForm.img_url})`}"></div>
          <div class="create-btn">
            <div class="btn circle" @click="drag.handleCreateBlock('circle', 'block-style-circle')"></div>
            <div class="btn" @click="drag.handleCreateBlock()"></div>
          </div>
        </div>
      </el-form-item>

      <vue-dividing-line title="解答思路"></vue-dividing-line>
      <Tinymce v-model="rulesForm.explanation"></Tinymce>
      <div class="sibmit-button">
        <div class="left">
          <el-button type="info" @click="onSubmit">提交</el-button>
          <el-button type="success" @click="onBack">取消</el-button>
        </div>
        <el-button type="info" @click="preview">預覽題目</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import upload from "@/components/upload";
import Tinymce from "@/components/Tinymce";
import rules from "../plugins/validator";
import HotspotDrag from '../plugins/hotspotDrag';
import { symbol } from '../plugins/directive'
export default {
  directives: {
    symbol
  },
  props: ['formLabelAlign'],
  components: { Tinymce, upload },
  data() {
    return {
      video: {
        url: null,
        // url: "https://api.dogecloud.com/player/get.mp4?vcode=5ac682e6f8231991&userId=17&ext=.mp4",
        cover: "",
        muted: false,
        loop: false,
        preload: "auto",
        poster: "",
        volume: 1,
        autoplay: false,
      },
      // 语言
      lang: [
        {label: '中文', value: 0},
        {label: '英文', value: 1},
      ],
      // 难易程度
      level: [
        {label: '※', value: 1},
        {label: '※※', value: 2},
        {label: '※※※', value: 3},
        {label: '※※※※', value: 4},
        {label: '※※※※※', value: 5},
      ],

      rulesForm: {},
      // rulesForm: {
      //   lang: "",
      //   title: "",
      //   img_url: '',
      //   type: 4,
      //   score: 1,
      //   level: 1,
      //   explanation: '',
      //   answers: [],
      //   choices: [],
      //   content: ''
      // },
      rules, 
      units: [],
      
      drag: null,
      hotspotData: []
    };
  },
  methods: {
    preview() {
      let form = this.handleFromData()
      form.type = 4
      this.$emit('preview', form)
    },
    onUploadSuccess(url) {
      this.rulesForm.img_url = url;
    },
    handleFromData() {
      let form = JSON.parse(JSON.stringify(this.rulesForm)),
      { hotspotData } = this
      form.answers = []
      form.choices = []
      // 处理數据
      hotspotData.filter((item, idx) => {
        if(item.mislead) form.answers.push({value: String(idx)})
        form.choices.push({value: JSON.stringify(item)})
      })
      form.content = JSON.stringify({
        hotspotData
      })

      return form
    },
    // 返回
    onBack() {
      this.$emit('cancel', this.rulesForm)
    },
    // 提交
    onSubmit() {
      let form = this.handleFromData()

      // type, type_display
      this.$emit('save', form, 4, 4)
    },
  },
  created() {
    this.rulesForm = {...this.formLabelAlign}
  },
  mounted() {
    let t = null
    this.drag = new HotspotDrag({
      plate: '.hotspot-canvas',
      blockStyle: {
        style: 'block-style',
        selectStyle: 'block-style-select'
      },
      maxNum: 100
    })
    this.drag.callback((map) => {
      if(t != null) {
        clearTimeout(t)
        t = null
      }

      t = setTimeout(() => {
        // 处理數据
        let arr = [...map.values()]
        this.hotspotData = arr

        t = null
      }, 500)
    })

    if(this.rulesForm.id) {
      let {hotspotData} = JSON.parse(this.rulesForm.content)
      this.hotspotData = hotspotData
      this.drag.handleEchoBlock(hotspotData, this)
    }
  }
};
</script>

<style lang="scss" scoped>
.hotspot {

  .design {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    margin: 20px 0 0 20px;
    .hotspot-canvas {
      width: 500px;
      height: 300px;
      border: 1px dashed #ccc;
      box-sizing: initial;
      background-size: 100% 100%;
      background-repeat: no-repeat;
      background-position: center center;
    }

    .create-btn {
      margin-left: 10px;
      .btn {
        width: 80px;
        height: 80px;
        margin-bottom: 10px;
        border-radius: 5px;
        background-color: #fea361;
        box-shadow: 1px 3px 3px 0 #ccc;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;

        &:before {
          content: '';
          width: 50px;
          height: 50px;
          border: 2px dashed #333;
        }
      }

      .circle {
        &:before {
          border-radius: 50%;
        }
      }
    }
  }
  
}
</style>

<style lang="scss"> 
.hotspot {

  .block-style {
    position: absolute;
    top: 80px;
    left: 80px;
    width: 80px;
    height: 80px;
    cursor: pointer;
    z-index: 1;
    background-color: transparent;
    background-size: 100% 100%;
    
    &:before {
      content: '';
      border: 1px dashed #333;
    }
  }

  .block-style-circle {
    position: absolute;
    top: 80px;
    left: 80px;
    width: 80px;
    height: 80px;
    border-radius: 50%;
    cursor: pointer;
    z-index: 1;
    background-color: transparent;
    background-size: 100% 100%;
    // outline: 1px dashed #333;
  }

  .correct {
    outline: 1px dashed #00d767;
    // &:before {
    //   border-color: greenyellow;
    // }
  }

  .error-block-style {
    &:before {
      border-color: red !important;
    }

    & > * {
      border-color: red !important;
    }
  }

  .block-style-select {
    // outline: none;

    &:before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      // border: none;
    }

    $dragSize: 8px;
    $shifting: -calc(8px - 2px) / 2;
    .drag {
      position: absolute;
      width: $dragSize;
      height: $dragSize;
      border: 1px solid #7e7e7e;
      box-sizing: border-box;
      background-color: #fff;
      margin: auto;
    }

    .leftTop {
      top: $shifting;
      left: $shifting;
      cursor: nw-resize;
    }

    .top {
      top: $shifting;
      left: 0;
      right: 0;
      cursor: n-resize;
    }

    .rightTop {
      top: $shifting;
      right: $shifting - 2px;
      cursor: ne-resize;
    }

    .right {
      right: $shifting - 2px;
      top: 0;
      bottom: 0;
      cursor: e-resize;
    }

    .rightBottom {
      right: $shifting - 2px;
      bottom: $shifting - 2px;
      cursor: se-resize;
    }

    .bottom {
      left: 0;
      right: 0;
      bottom: $shifting - 2px;
      cursor: s-resize;
    }

    .leftBottom {
      left: $shifting;
      bottom: $shifting - 2px;
      cursor: sw-resize;
    }

    .left {
      top: 0;
      bottom: 0;
      left: $shifting;
      cursor: w-resize;
    }
  }
}
.right-key-menu {
  width: 150px;
  padding: 5px 0;
  box-sizing: border-box;
  background-color: #fff;
  box-shadow: 1px 1px 3px 1px #ccc;
  border-radius: 3px;
  position: absolute;
  top: 0;
  z-index: 9999;
  outline: none;

  .menu-single {
    width: 100%;
    padding: 5px;
    box-sizing: border-box;
    border-bottom: 1px solid #eee;
    font-size: 13px;
    text-align: center;
    cursor: pointer;

    &:hover {
      background-color: #eee;
    }
  }

  .menu-single:nth-last-of-type(1) {
    border: none;
  }
}

</style>